export enum ExternalProjectAssociationStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ExternalProjectAssociationType {
  BILL_TO_ACCOUNT = 'Bill To Account',
  SHIP_TO_ACCOUNT = 'Ship To Account',
}

export enum ExternalProjectRecordType {
  FUNDED_PROJECT = 'Funded Project',
  PROGRAM = 'Program',
  PROJECT = 'Project',
  UNFUNDED_PROJECT = 'Unfunded Project',
}
